module.exports = __webpack_public_path__ + "fonts/dm-sans-v10-latin-regular.3343c4c.woff";